import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <div className="w-24 h-24 flex items-center justify-center mb-6">
        <i className="ri-error-warning-line text-6xl text-foreground-300"></i>
      </div>
      <h1 className="font-heading text-4xl md:text-5xl text-foreground-900 mb-3">404</h1>
      <p className="text-lg text-foreground-600 mb-2">页面未找到</p>
      <p className="text-sm text-foreground-500 mb-8">您访问的页面不存在或已被移除</p>
      <Link
        to="/"
        className="inline-flex px-6 py-3 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        返回首页
      </Link>
    </div>
  );
}